import React, { useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";



import {
  Button,
  Card,
  Input,
  FormGroup,
  RadioGroup,
  Icon,
  ButtonAction
} from "xsolla-uikit";

import { xsollaProducts } from "../data/xsollaProducts";
import { solutions } from "../data/solutions";

import { Switch, Route, Link } from "react-router-dom";
import merge from "deepmerge";


export function PAintegrationFlow({ flow = "preorders" }) {
  const [state, setState] = useState({
    flow: flow,
    solutions: merge({}, {...solutions}),
    step: 0,
  });

  let name = solutions[flow]['name'];
  let description = solutions[flow]['description'];


  const getData = (what = 'name') => {
    return state.solutions[state.flow][what]
  }

  return (
    <div className="">
      {state["flow"] === 'preorders' && (
        // && state['step'] === 1
        <div>



              <Button appearance='flatten'
              onClick={()=>{
                setState({
                  ...state,
                  flow: null,
                })
              }}
              >
              <Icon name="chevron-reverse"/>
              All solutions
              </Button>



              <h3>{getData('name')}</h3>

                <FormGroup indentation='xs'>
                  <p
                  // style={{color: '#A0ABB8'}}
                  >
                    {getData('description')}
                  </p>
                  </FormGroup>



                  <FormGroup indentation='xs'>

                    {state['solutions'][state.flow]['products'].map((oneProduct, ind)=>{
                      return (
                        <FormGroup indentation='xs' key={`prod_${ind}`}>
                      <div
                        onClick={()=>{{
                          setState({
                            ...state,
                            step: ind
                          })
                        }}}
                      >
                      <PAtodoItem
                        // appearance="flatten"
                        active = {state.step === ind ? true : false}
                        stepNumber = {ind}
                        key={`int_step_${ind}`}
                        link={oneProduct['link']}
                        name={oneProduct['name']}
                        product={oneProduct['product']}
                        status={state['solutions'][state.flow]['status']}
                      />
                      </div></FormGroup>
)                    })}
                  </FormGroup>








              </div>
            // </div>
          // </div>
        // </div>
      )}
    </div>
  );
}



export default function PAonboarding({ flow = "preorders", children }) {
  const [state, setState] = useState({
    flow: flow,
    step: 0
  });

  return (
    <div
      style={{
        width: 440,
        height: "100vh",
        position: "relative"
      }}
    >
      <div
        style={{
          //  position: 'fixed',
          width: 440,
          top: 0,
          left: 0,
          bottom: 0
        }}
      >
        <div
          style={{
            position: "fixed",
            width: 440,
            height: "100vh",
            backgroundColor: "white",
            boxShadow: "inset -4px 0 10px -4px rgba(0,0,0, 0.3)"
          }}
        >
          <div className="side-panel__container">
            <div
              // className="side-panel__header"
              style={{
                padding: "28px 28px 16px 28px"
                // display: 'flex',
              }}
            >
              <FormGroup label="Project">
                <div
                  style={{
                    display: "flex"
                  }}
                >
                  <div
                    className="xsui-select"
                    style={{
                      // width: '100%'
                      flexGrow: 1
                    }}
                  >
                    <div className="xsui-dropdown">
                      <div style={{ display: "block" }}>
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            display: "block"
                          }}
                        >
                          <button
                            value="test setup"
                            placeholder="Select"
                            className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only"
                            type="button"
                            data-value="test setup"
                          >
                            test setup
                          </button>
                          <div className="xsui-input__icon">
                            <i
                              className="xsui-icon xsui-icon-dropdown-select"
                              style={{ fontSize: 24, color: "inherit" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div style={{ marginLeft: 12 }}>
                    <div
                      style={{
                        borderRadius: 4,
                        display: "flex",
                        padding: "0 4px",
                        justifyContent: "center",
                        border: "1px solid rgba(0,115,247,.32)",
                        height: 44,
                        alignItems: "center",
                        minWidth: 44
                      }}
                    >
                      <Icon size={24} name="settings" />
                      {/* Project Settings */}
                    </div>
                  </div>
                </div>
              </FormGroup>

              <PAintegrationFlow flow={state["flow"]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



export function PAtodoStatus ({status = 0, style}) {
  return (
    <div style={{...style}}>
    {!status && <img
      className="todo-item__icon todo-item__icon--sub-item"
      src="//cdn.xsolla.net/publisher-v4/unavailable.61fb11.svg"
      alt="active"
    />}

    {status === 4 && <img
      className="todo-item__icon todo-item__icon--sub-item"
      src="//cdn.xsolla.net/publisher-v4/active.8e7bc2.svg"
      alt="active"
    />}
    </div>

  )
}


export function PAtodoItem ({
  name = 'No title',
  description = '',
  optional = false,
  status = 0,
  active = false,
  learnMoreUrl = '/',
  appearance='regular', //regular,flatten
  // callBack = () => void(0),
}) {
  return (
    <Link
      to={learnMoreUrl}
      style={{
        minHeight: 56,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'space-between',
        justifyContent: 'center',
      }}
      className={appearance === 'regular' ? `todo-item todo-item--sub-item` : ``}
    >

      <div className={appearance==='regular' ? `todo-item__heading todo-item__heading--pointer todo-item__heading--sub-item todo-item__heading--hover` :
        `todo-item__heading`
      }>
        <div className="todo-item__content-wrapper">
          <PAtodoStatus status={status}
            // style={{opacity: active ? 0 : 1}}
          />
          <CssTodoName className="todo-item__content" moved={active}>
            <p className="todo-item__name">{name}</p>
          </CssTodoName>
        </div>
        <div className="todo-item__icon-wrapper">
          <CssActive active={active}>
          <Icon name="chevron-mini"
            style={{ fontSize: 20 }}
          />
          </CssActive>
        </div>
      </div>

    </Link>
  )
}

const CssTodoName = styled.div`
  transition: all 150ms ease-in-out;
  /* transform: translateX(${props => props.moved ? "-36px" : "0"}) */
`
const CssActive = styled.div`
  transition: all 150ms ease-in-out;
  width: 24px;
  height: 24px;
  border-radius: 100px;
  display: flex;
  place-content: center center;
  color: ${props => props.active ? "white" : "rgb(204, 208, 211)"};
  background-color: ${props => props.active ? "#0073f7" : "transparent"};
`
